
import { getMarketsList } from '@/api/markets.js'
import { getSupplierList } from '@/api/supplier.js'
const project = {
  state: {
    marketList: [], // 商机(市场)列表
    supplierList: [], // 供应商列表
    projectTypeList: [], // 项目类型列表
    marketTypeList: [] // 市场类型列表
  },
  getters: {
    // goodsTypeList: state => state.goodsTypeList,
    // receiveSendTypeList: state => state.receiveSendTypeList,
    // suppliesTypeList: state => state.suppliesTypeList,
    projectTypeList: state => state.projectTypeList,
    marketTypeList: state => state.marketTypeList
  },
  mutations: {
    marketList: (state, marketList) => {
      state.marketList = marketList
    },
    supplierList: (state, supplierList) => {
      state.supplierList = supplierList
    },
    projectTypeList: (state, projectTypeList) => {
      state.projectTypeList = projectTypeList
    },
    marketTypeList: (state, marketTypeList) => {
      state.marketTypeList = marketTypeList
    }
  },
  actions: {
    handleMarketList (marketList, data) {
      getMarketsList({ paging: false }).then(res => {
        if (res.status === 0) {
          marketList.commit('marketList', res.data)
        }
      })
    },
    handleSupplierList (supplierList, data) {
      getSupplierList({ paging: false }).then(res => {
        if (res.status === 0) {
          supplierList.commit('supplierList', res.data)
        }
      })
    },
    handleProjectTypeList (projectTypeList, data) {
      projectTypeList.commit('projectTypeList', data)
    },
    handleMarketTypeList (marketTypeList, data) {
      marketTypeList.commit('marketTypeList', data)
    }
  }
}

export default project
